<template>
  <v-dialog :value="value"
            persistent
            width="400">
    <h6 :class="$style.modalTitle">
      Please fill all necessary fields.
    </h6>
    <div :class="$style.errorsMessages">
      <slot />
    </div>
    <app-button text="OK" button-style="accent" :class="$style.okBtn" @click="closeErrorsDialog" />
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeErrorsDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
.okBtn {
  display: block;
  margin: 0 auto;
  max-width: 120px;
  text-align: center;
  padding: 6px 0;
}

.errorsMessages {
  margin-top: 10px;
  text-align: center;
}
</style>
